// ======================================================================
// File Name       : PageBodyContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import LeftNavigator from '../components/LeftNavigator';
import MessageView from '../components/MessageView';
import { CONTENT_QUESTION_DETAIL_PREVIEW_REG_EXP, DEFAULT_DATE_FORMAT_SHORT_DETAIL, SUPER_USER } from '../constants';
import { HIDDEN_STATUS } from '../constants/EnterpriseConstants';
import * as Path from '../constants/PathConstants';
import { HIDE_MESSAGE } from '../constants/actionTypes/message';
import * as actionType from '../constants/actionTypes/page';
import { canAccessRoute, getTopPage } from '../utils/AuthedUtils';
import {
  checkSearchCondition,
  checkSearchConditionSub,
  setGTMConfig,
  isEnterpriseFunctions,
} from "../utils/PageUtils";
import { isSuperUser } from '../utils';

const MainView = ({ routes, className }) => {
  const AccessRoute =
    routes &&
    <Switch>
      {routes.map((route) => {
        const havePathParam = /:[0-9a-zA-Z].+/.test(route.path);
        return (
          <Route
            key={route.id}
            path={route.path}
            exact={!havePathParam}
            component={route.container}
          />
        );
      })}
      <Redirect from="/" to={Path.TOP_LIST} />
    </Switch>;

  return (
    <div>
      {AccessRoute}
    </div>
  );
};

class PageBody extends Component {
  constructor() {
    super();
    this.state = {
      toShow: false,
      scrollTop: true,
      showMenu: true,
      isCollapsedMode: false,
    };
    this.dismissMessage = this.dismissMessage.bind(this);
    this.collapsibleMenu = this.collapsibleMenu.bind(this);
    this.mouseEnterLeftMenu = this.mouseEnterLeftMenu.bind(this);
    this.mouseLeaveLeftMenu = this.mouseLeaveLeftMenu.bind(this);
  }

  componentWillMount() {
    this.setState({
      toShow: true,
    });
    setGTMConfig();
    window.appendCorsIframe();
  }

  componentDidMount() {
    $('#sroll-container').scroll(() => {
      if ($('#sroll-container').scrollTop() > 100) {
        $('#scropToTop').fadeIn(300);
      } else {
        $('#scropToTop').fadeOut(300);
      }
    });
  }

  dismissMessage() {
    this.props.dispatch({
      type: HIDE_MESSAGE,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { match, parentPath, parentPathSub, parentPathHistory } = nextProps;
    const { url } = match;
    if (url && parentPath) {
      checkSearchCondition(url, parentPath);
    }
    if (url && parentPathSub) {
      checkSearchConditionSub(url, parentPathSub);
    }
    if (url && parentPathHistory) {
      checkSearchConditionSub(url, parentPathHistory);
    }
    if (this.props.reloadComponent !== nextProps.reloadComponent) {
      setTimeout(() => {
        this.props.dispatch({
          type: actionType.CLEAR_SEARCH_CONDITION,
        });
        this.props.dispatch({
          type: actionType.CLEAR_SEARCH_CONDITION_SUB,
        });
        this.setState({
          toShow: true,
        });
      }, 100);
      this.setState({
        toShow: false,
      });
    }
    if (nextProps.location.pathname === this.props.location.pathname) {
      this.setState({
        scrollTop: false,
      });
    } else {
      if (this.state.scrollTop === false) {
        this.setState({
          scrollTop: true,
        });
      }
    }
  }

  // STEP9.0.1 START
  collapsibleMenu() {
    const { isCollapsedMode } = this.state;
    if (isCollapsedMode) {
      this.setState({
        ...this.state,
        showMenu: true,
        isCollapsedMode: false,
      });
    } else {
      this.setState({
        ...this.state,
        showMenu: false,
        isCollapsedMode: true,
      });
    }
  }

  mouseEnterLeftMenu() {
    const { isCollapsedMode } = this.state;
    if (isCollapsedMode) {
      this.setState({
        ...this.state,
        showMenu: true,
      });
    }
  }

  mouseLeaveLeftMenu() {
    const { isCollapsedMode } = this.state;
    if (isCollapsedMode) {
      this.setState({
        ...this.state,
        showMenu: false,
      });
    }
  }
  // STEP9.0.1 END

  render() {
    const container = $('#sroll-container');
    if (container && container.length && this.state.scrollTop) {
      container.scrollTop(0);
    }
    const {
      match,
      routes,      
      message,
      authedUser,
      leftNavigatorDatas,
      hideTopMenu,
      logout,
      showContentsOnly,
      isShowContract,
      isTrialExpire,
      isSuperUserL0,
    } = this.props;
    const { serviceName, enterpriseName, userName, serviceCd } = this.props.panelData;
    const { url } = match;
    const rootPath = url.split('/')[1] || 'top';
    const { displayUserType, lastLoginTime } = authedUser.userInfo;
    const {contractEnterpriseHiddenStatus, isEnterpriseLayerL1} = authedUser
    const isSuperUserL1 = [SUPER_USER].indexOf(displayUserType) > -1 && isEnterpriseLayerL1;
    const isServiceInformationScreen = url.includes('service/detail');
    const isEnterpriseFunction = isEnterpriseFunctions(url); // Step 12.0.0 TAS-18955
    const isShowSuperUserInitMenu = (isSuperUser(displayUserType)
    && ((serviceCd == null && !isServiceInformationScreen) || isEnterpriseFunction));
    let serviceTitle;
    let enterpriseTitle;
    if (serviceName) serviceTitle = `${serviceName} サービス`;
    if (enterpriseName) enterpriseTitle = `${enterpriseName} 企業`;
    const rightMenuTitle = (
      <div className="user-menu-position">
        {/* Step 9.0.1 START */}
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {serviceName || enterpriseName}
        </span>
      </div>
    );

    const subRoute = routes[rootPath];
    const isShowLeftNav = (url !== Path.PREVIEW_EACH_QUESTION_ATTRIBUTE &&
                           !url.match(CONTENT_QUESTION_DETAIL_PREVIEW_REG_EXP));
    const containerStyle = isShowSuperUserInitMenu
      ? 'container-init-menu scrollSize break-text breakDot padding-left-right-clear'
      : 'scrollSize break-text breakDot padding-left-right-clear';
    const hiddenStatus = (isSuperUserL0 || isSuperUserL1) ? HIDDEN_STATUS.SHOW_ALL : contractEnterpriseHiddenStatus;
    return ( 
      <div
        className={
          isShowLeftNav
            ? `container margin-clear ${containerStyle}`
            : `container-preview ${containerStyle}`
        }
      >
        <div
          className={`${isShowLeftNav ? 'row content' : 'row'} ${isShowSuperUserInitMenu ? 'content-init-menu' : ''}`}
          style={{ marginLeft: '0px' }}
        >
          {isShowLeftNav && !isShowSuperUserInitMenu && (
            <LeftNavigator
              {...this.props} 
              leftNavigatorDatas={leftNavigatorDatas}
              url={url}
              logout={logout}
              rightMenuTitle={rightMenuTitle}
              isTrialExpire={isTrialExpire}
              isShowContract={isShowContract}
              hideTopMenu={hideTopMenu}
              showContentsOnly={showContentsOnly}
              displayUserType={displayUserType}
              hiddenStatus={hiddenStatus}
              showMenu={this.state.showMenu}
              isCollapsedMode={this.state.isCollapsedMode}
              collapsibleMenu={this.collapsibleMenu}
              mouseEnterLeftMenu={this.mouseEnterLeftMenu}
              mouseLeaveLeftMenu={this.mouseLeaveLeftMenu}
            />
          )}
          <div className={`${isShowLeftNav ? 'main-container-100 text-left' : 'margin-left-20 text-left'}`
            + `${!this.state.showMenu || (this.state.isCollapsedMode && this.state.showMenu)
              ? ' main-container-collapse-menu': ''}`
            + `${isShowSuperUserInitMenu ? ' main-container-init-menu' : ' margin-top-60'}`}
          >
            {subRoute &&
              <Switch>
                {subRoute.map((route) => {
                  if (route) {
                    if (!canAccessRoute(route.id)) {
                      const topPage = getTopPage();
                      return <Redirect key={topPage} from="/" to={topPage} />;
                    }
                  }
                  const havePathParam = /:[0-9a-zA-Z].+/.test(route.path);
                  return (
                    <Route
                      key={route.id}
                      path={route.path}
                      exact={!havePathParam}
                      render={(props) => {
                        const component = (
                          <div>
                            {message.messageVisible &&
                              !message.targetModal &&
                              <MessageView message={message} onDismiss={this.dismissMessage} />}
                            <route.container {...props} />
                          </div>
                        );
                        return component;
                      }}
                    />
                  );
                })}
                <Redirect from="/" to={Path.TOP_LIST} />
              </Switch>}
          </div>
        </div>
      </div>
    );
  }
}

PageBody.propTypes = {
  routes: PropTypes.shape(),
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { routes, leftNavigatorDatas, authedUser } = state.authed;
  const { message } = state;
  const { enterpriseName, serviceName, userInfo, serviceCd} = authedUser;
  const { reloadComponent, parentPath, parentPathSub, parentPathHistory } = state.page;
  return {
    panelData:
    { enterpriseName, serviceName, userName: userInfo.userName, serviceCd },
    routes, leftNavigatorDatas, message, reloadComponent, parentPath, parentPathSub, parentPathHistory, authedUser};
};
export default connect(mapStateToProps)(PageBody);
